// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_icons.styl
// module id = 93
// module chunks = 0